module.exports = __webpack_public_path__ + "static/img/8.270dbc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/8.png
// module id = GWtx
// module chunks = 0